import React from 'react';
import { Box, Grid, TextField, Typography } from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import IconButton from '@material-ui/core/IconButton';

export const PageNav = ({
  isFecthing,
  maxPage,
  handlePageMove,
  pageInput,
  handleInputChange,
}) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box>
        <IconButton
          aria-label="предишна страница"
          onClick={handlePageMove(-1)}
          disabled={pageInput <= 1 || isFecthing}
        >
          <KeyboardArrowLeft color="primary" />
        </IconButton>
        <Typography component="span" color="primary">
          Страница {pageInput} от {maxPage}.
        </Typography>
        <IconButton
          aria-label="следваща страница"
          onClick={handlePageMove(1)}
          disabled={isFecthing || pageInput >= maxPage}
        >
          <KeyboardArrowRight color="primary" />
        </IconButton>
      </Box>

      <>
        <TextField
          onChange={handleInputChange}
          type="number"
          label="Номер на страницата"
          id="pageNumber"
          value={pageInput}
        ></TextField>
      </>
    </Grid>
  );
};
